export type LoginOtpMethod = 'phone' | 'email';

export interface PendingLoginOtpSession {
  phoneNumber: string;
  email?: string;
  method?: LoginOtpMethod;
  displayedPhoneNumber: string;
  displayedLoginTarget?: string;
  createdAt: number;
}

const PENDING_LOGIN_OTP_KEY = 'pendingLoginOtp';
const PENDING_LOGIN_OTP_TTL_MS = 5 * 60 * 1000;

export const savePendingLoginOtp = (
  loginTarget: string,
  displayedLoginTarget: string,
  method: LoginOtpMethod = 'phone'
): void => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  sessionStorage.setItem(PENDING_LOGIN_OTP_KEY, JSON.stringify({
    phoneNumber: method === 'phone' ? loginTarget : '',
    email: method === 'email' ? loginTarget : undefined,
    method,
    displayedPhoneNumber: method === 'phone' ? displayedLoginTarget : '',
    displayedLoginTarget,
    createdAt: Date.now()
  }));
};

export const getPendingLoginOtp = (): PendingLoginOtpSession | null => {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }

  const rawSession = sessionStorage.getItem(PENDING_LOGIN_OTP_KEY);
  if (!rawSession) {
    return null;
  }

  try {
    const session = JSON.parse(rawSession) as PendingLoginOtpSession;
    const method = session.method || 'phone';
    const loginTarget = method === 'email' ? session.email : session.phoneNumber;
    if (!loginTarget || Date.now() - session.createdAt >= PENDING_LOGIN_OTP_TTL_MS) {
      clearPendingLoginOtp();
      return null;
    }
    return session;
  } catch (error) {
    clearPendingLoginOtp();
    return null;
  }
};

export const clearPendingLoginOtp = (): void => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  sessionStorage.removeItem(PENDING_LOGIN_OTP_KEY);
};

export const hasPendingLoginOtp = (): boolean => {
  return getPendingLoginOtp() !== null;
};

export const getPendingLoginOtpRemainingSeconds = (): number => {
  const session = getPendingLoginOtp();
  if (!session) {
    return PENDING_LOGIN_OTP_TTL_MS / 1000;
  }

  const elapsedMs = Date.now() - session.createdAt;
  return Math.max(Math.ceil((PENDING_LOGIN_OTP_TTL_MS - elapsedMs) / 1000), 0);
};
